/**
 * Scrambles an array, with optional max amount to return
 *
 * @param source T[]
 * @param max number of items to return
 */
export default function randomArray<T>(source: T[], max?: number): T[] {
  const copyOfSource = [...source];
  const maxLength = max && copyOfSource.length >= max ? max : copyOfSource.length;
  const picked: T[] = [];
  for (let i = 0; i < maxLength; i++) {
    const index = Math.floor(Math.random() * copyOfSource.length);
    picked.push(copyOfSource[index]);
    copyOfSource.splice(index, 1);
  }
  return picked;
}
